// Works in Vite, CRA/Webpack, Next, etc. Never throws when import.meta is undefined.
const vite = (typeof import.meta !== "undefined" && import.meta.env) || {};
const cra  = (typeof process !== "undefined" && process.env) || {};

export const env = {
  API_BASE_URL:
    vite.VITE_API_BASE_URL ??
    cra.REACT_APP_API_BASE_URL ??
    cra.NEXT_PUBLIC_API_BASE_URL ??
    "",

  USE_MOCK:
    vite.VITE_USE_MOCK ??
    cra.REACT_APP_USE_MOCK ??
    "0",

  MODE:
    vite.MODE ??
    cra.NODE_ENV ??
    "development",

  BASE_URL:
    vite.BASE_URL ??
    cra.PUBLIC_URL ??
    "/",
};
